export const DeviceTypeHandler = ({ desktopDeviceComponent, mobileDeviceComponent, tabletDeviceComponent }) => {
    const tabletComponent =
        typeof tabletDeviceComponent === 'undefined' ? desktopDeviceComponent : tabletDeviceComponent

    const deviceComponentsMap = {
        desktop: desktopDeviceComponent,
        mobile: mobileDeviceComponent,
        tablet: tabletComponent
    }

    const getDeviceType = () => {
        const userAgent = navigator.userAgent

        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(userAgent)) {
            return 'tablet'
        }
        // eslint-disable-next-line max-len
        else if (
            /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
                userAgent
            )
        ) {
            return 'mobile'
        }
        return 'desktop'
    }

    return deviceComponentsMap[getDeviceType()]
}
